import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class PreloaderResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("PreloaderResourcesPackage");
    }
    public get assets_preloader_preloader_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/preloader/preloader_1x.atlas.json");
    }
    public get assets_preloader_progress_bar_bg_png(): Texture {
        return this.assets_preloader_preloader_1x_atlas_json.textures["progress_bar_bg.png"];
    }
    public get assets_preloader_progress_bar_png(): Texture {
        return this.assets_preloader_preloader_1x_atlas_json.textures["progress_bar.png"];
    }
    public get assets_preloader_preloader_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/preloader/preloader_1x.atlas.png");
    }
}

